const { fetchQuery, graphql } = require('react-relay');
const { cookieJarConstants, getUserId } = require('dibs-cookie-jar');
const get = require('lodash.get');

const { getEnvironment } = require('../global/relayEnvironmnentProvider.es');

const fetchLoyaltyStatusQuery = graphql`
    query fetchLoyaltyStatusQuery($userId: String!, $hasUserId: Boolean!) {
        viewer {
            user(userId: $userId) @include(if: $hasUserId) {
                tradeFirm {
                    loyalty {
                        status
                    }
                }
            }
        }
    }
`;

module.exports = function fetchLoyaltyStatus() {
    const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

    return fetchQuery(getEnvironment(), fetchLoyaltyStatusQuery, {
        userId,
        hasUserId: !!userId,
    }).then(data => {
        const loyaltyStatus = get(data, 'viewer.user.tradeFirm.loyalty.status');
        return loyaltyStatus;
    });
};



// WEBPACK FOOTER //
// ./assets/js/trade/fetchLoyaltyStatus.es.js